import { createSystem, defaultConfig } from "@chakra-ui/react";
import '@fontsource/hanken-grotesk';

const colors = {
    black: "#0d1016",
    gray: {
        50: {
            value: "#f9fafa",
        },
        100: {
            value: "#f1f1f2",
        },
        200: {
            value: "#e7e7e9",
        },
        300: {
            value: "#d3d4d6",
        },
        400: {
            value: "#aaadb1",
        },
        500: {
            value: "#7c7f86",
        },
        600: {
            value: "#50555e",
        },
        700: {
            value: "#313742",
        },
        800: {
            value: "#1a202c",
        },
        900: {
            value: "#151a23",
        },
    },
    green: {
        50: {
            value: "#f2fef8",
        },
        100: {
            value: "#b2fad7",
        },
        200: {
            value: "#38f298",
        },
        300: {
            value: "#05da73",
        },
        400: {
            value: "#04bf65",
        },
        500: {
            value: "#03a457",
        },
        600: {
            value: "#038848",
        },
        700: {
            value: "#026a38",
        },
        800: {
            value: "#02572e",
        },
        900: {
            value: "#014826",
        },
    },
    teal: {
        50: {
            value: "#ebfdfe",
        },
        100: {
            value: "#9ef7f9",
        },
        200: {
            value: "#0fecf0",
        },
        300: {
            value: "#04d3d6",
        },
        400: {
            value: "#04b3b6",
        },
        500: {
            value: "#03989b",
        },
        600: {
            value: "#037c7e",
        },
        700: {
            value: "#026062",
        },
        800: {
            value: "#025052",
        },
        900: {
            value: "#014243",
        },
    },
    cyan: {
        50: {
            value: "#f1fcfe",
        },
        100: {
            value: "#c3f1fb",
        },
        200: {
            value: "#a7eaf9",
        },
        300: {
            value: "#84e2f7",
        },
        400: {
            value: "#07c4ef",
        },
        500: {
            value: "#05b4dc",
        },
        600: {
            value: "#04a3c6",
        },
        700: {
            value: "#0387a4",
        },
        800: {
            value: "#036f87",
        },
        900: {
            value: "#025669",
        },
    },
    blue: {
        50: {
            value: "#f0f7fe",
        },
        100: {
            value: "#c7e0fb",
        },
        200: {
            value: "#9ecaf9",
        },
        300: {
            value: "#6fb0f6",
        },
        400: {
            value: "#4096f3",
        },
        500: {
            value: "#127df0",
        },
        600: {
            value: "#0467d1",
        },
        700: {
            value: "#034fa0",
        },
        800: {
            value: "#034184",
        },
        900: {
            value: "#02356c",
        },
    },
    purple: {
        50: {
            value: "#f9f5fe",
        },
        100: {
            value: "#e6d9fd",
        },
        200: {
            value: "#d3bdfb",
        },
        300: {
            value: "#b793f8",
        },
        400: {
            value: "#a375f6",
        },
        500: {
            value: "#864cf4",
        },
        600: {
            value: "#6f29f1",
        },
        700: {
            value: "#5305e3",
        },
        800: {
            value: "#4504bd",
        },
        900: {
            value: "#34038f",
        },
    },
    pink: {
        50: {
            value: "#fef5f9",
        },
        100: {
            value: "#fcd7e9",
        },
        200: {
            value: "#fab5d7",
        },
        300: {
            value: "#f785bc",
        },
        400: {
            value: "#f55da6",
        },
        500: {
            value: "#ee0576",
        },
        600: {
            value: "#cd0465",
        },
        700: {
            value: "#a80453",
        },
        800: {
            value: "#850342",
        },
        900: {
            value: "#640231",
        },
    },
    red: {
        50: {
            value: "#fef5f5",
        },
        100: {
            value: "#fcd8d7",
        },
        200: {
            value: "#fab4b3",
        },
        300: {
            value: "#f78482",
        },
        400: {
            value: "#f56563",
        },
        500: {
            value: "#f12926",
        },
        600: {
            value: "#d40804",
        },
        700: {
            value: "#ac0604",
        },
        800: {
            value: "#930603",
        },
        900: {
            value: "#6d0402",
        },
    },
    orange: {
        50: {
            value: "#fefaf5",
        },
        100: {
            value: "#fcead7",
        },
        200: {
            value: "#f9d2a7",
        },
        300: {
            value: "#f5ad60",
        },
        400: {
            value: "#f08818",
        },
        500: {
            value: "#d67104",
        },
        600: {
            value: "#b45f04",
        },
        700: {
            value: "#904c03",
        },
        800: {
            value: "#713c02",
        },
        900: {
            value: "#5d3102",
        },
    },
    yellow: {
        50: {
            value: "#fffefa",
        },
        100: {
            value: "#fdf9e3",
        },
        200: {
            value: "#faeeac",
        },
        300: {
            value: "#f5e067",
        },
        400: {
            value: "#edca05",
        },
        500: {
            value: "#c3a604",
        },
        600: {
            value: "#9c8503",
        },
        700: {
            value: "#7a6803",
        },
        800: {
            value: "#5b4e02",
        },
        900: {
            value: "#4b4002",
        },
    },
    primary_second: {
        50: {
            value: "#e6fde7",
        },
        100: {
            value: "#8df890",
        },
        200: {
            value: "#05e50c",
        },
        300: {
            value: "#04c10a",
        },
        400: {
            value: "#04ac09",
        },
        500: {
            value: "#039207",
        },
        600: {
            value: "#037b06",
        },
        700: {
            value: "#026305",
        },
        800: {
            value: "#025404",
        },
        900: {
            value: "#013d03",
        },
    },

    text: {
        main: {
            value: "#f3f5f0",
        },
    },
    background: {
        main: {
            value: "#060703",
        },
        50: {
            value: "#f5f7ed",
        },
        100: {
            value: "#ebf0db",
        },
        200: {
            value: "#d6e0b8",
        },
        300: {
            value: "#c2d194",
        },
        400: {
            value: "#adc270",
        },
        500: {
            value: "#99b34d",
        },
        600: {
            value: "#7a8f3d",
        },
        700: {
            value: "#5c6b2e",
        },
        800: {
            value: "#3d471f",
        },
        900: {
            value: "#1f240f",
        },
    },
    primary: {
        main: {
            value: "#addcff",
        },
        50: {
            value: "#e5f4ff",
        },
        100: {
            value: "#cce9ff",
        },
        200: {
            value: "#99d3ff",
        },
        300: {
            value: "#66bdff",
        },
        400: {
            value: "#33a7ff",
        },
        500: {
            value: "#0091ff",
        },
        600: {
            value: "#0074cc",
        },
        700: {
            value: "#005799",
        },
        800: {
            value: "#003a66",
        },
        900: {
            value: "#001d33",
        },
    },
    secondary: {
        main: {
            value: "#1afbff",
        },
        50: {
            value: "#e5ffff",
        },
        100: {
            value: "#ccfeff",
        },
        200: {
            value: "#99fdff",
        },
        300: {
            value: "#66fcff",
        },
        400: {
            value: "#33fcff",
        },
        500: {
            value: "#00fbff",
        },
        600: {
            value: "#00c9cc",
        },
        700: {
            value: "#009699",
        },
        800: {
            value: "#006466",
        },
        900: {
            value: "#003233",
        },
    },
    accent_old: {
      main: {
          value: "#23d723",
      },
      50: {
          value: "#e9fbe9",
      },
      100: {
          value: "#d3f8d3",
      },
      200: {
          value: "#a7f1a7",
      },
      300: {
          value: "#7bea7b",
      },
      400: {
          value: "#50e250",
      },
      500: {
          value: "#24db24",
      },
      600: {
          value: "#1daf1d",
      },
      700: {
          value: "#158415",
      },
      800: {
          value: "#0e580e",
      },
      900: {
          value: "#072c07",
      },
    },
    accent_green: {
        main: {
            value: "#23d723",
        },
        50: {
            value: "#e9fbe9",
        },
        100: {
            value: "#d3f8d3",
        },
        200: {
            value: "#a7f1a7",
        },
        300: {
            value: "#7bea7b",
        },
        400: {
            value: "#50e250",
        },
        500: {
            value: "#24db24",
        },
        600: {
            value: "#1daf1d",
        },
        700: {
            value: "#158415",
        },
        800: {
            value: "#0e580e",
        },
        900: {
            value: "#072c07",
        },
    },
    accent: {
        main: {
            value: "#8b1fff",
        },
        50: {
            value: "#f2e5ff",
        },
        100: {
            value: "#e5ccff",
        },
        200: {
            value: "#ca99ff",
        },
        300: {
            value: "#b066ff",
        },
        400: {
            value: "#9633ff",
        },
        500: {
            value: "#7b00ff",
        },
        600: {
            value: "#6300cc",
        },
        700: {
            value: "#4a0099",
        },
        800: {
            value: "#310066",
        },
        900: {
            value: "#190033",
        },
      },
};

const activeLabelStyles = {
    transform: "scale(0.85) translateY(-24px)",
};

const system = createSystem(defaultConfig, {
    theme: {
        tokens: {
            colors,

            fonts: {
                heading: {
                    value: `'Hanken Grotesk', sans-serif`,
                },
                body: {
                    value: `'Hanken Grotesk', sans-serif`,
                },
            },
        },
    },

    components: {
        Form: {
            variants: {
                floating: {
                    container: {
                        _focusWithin: {
                            label: {
                                ...activeLabelStyles,
                            },
                        },
                        "input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label": {
                            ...activeLabelStyles,
                        },
                        label: {
                            top: 0,
                            left: 0,
                            zIndex: 2,
                            position: "absolute",
                            pointerEvents: "none",
                            mx: 3,
                            px: 1,
                            my: 2,
                            transformOrigin: "left top",
                        },
                    },
                },
            },
        },
    },
});

export default system;
